import { configureStore } from '@reduxjs/toolkit';

import { account } from '@redux/account';
import { devices } from '@redux/devices';
import { playlists } from '@redux/playlists';

// Middleware to auto-refresh user data after device operations
const autoRefreshUserMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Auto-refresh user data after successful device operations
  if (action.type === 'devices/purchaseDeviceSubscription/fulfilled' || 
      action.type === 'devices/reduceDeviceSlots/fulfilled') {
    // Dispatch fetchUser to refresh all user data automatically
    store.dispatch(account.actions.fetchUser());
  }
  
  return result;
};

export default configureStore({
  reducer: {
    user: account.reducer,
    devices: devices.reducer,
    playlists: playlists.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(autoRefreshUserMiddleware),
});
